import React, {useState, useCallback, useEffect, useRef} from 'react';
import {DebounceInput} from 'react-debounce-input';
import { useDispatch } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import {useList} from 'react-use';

import {
    getPlayers
} from './../../../../../actions/leader-board';
import styles from '../../../../../components/dropdown/dropdown.module.css';

function PlayerSearch(props) {
    const [players] = useList([]);
    const [suggestions, setSuggestions] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [value, setValue] = useState('');
    const dispatch = useDispatch();

    const wrapperRef = useRef(null);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setToggle(false);
        }
    }, []);

    const onSearch = useCallback(async (value) => {
        try {
            const result = await dispatch(getPlayers({
                keyword: value,
                teamIds: props.teamIds,
            }));
            setToggle(true);
            setSuggestions(result);
        }catch (e) {
            setSuggestions([]);
            setToggle(true);
        }
    }, [props]);

    const onAddPlayer = useCallback((player) => {
        if(players.find(item => item.id === player.id)) return;
        props.onChoosePlayer(player);
    }, [players]);

    PlayerSearch.handleClickOutside = useCallback(() => {
        setToggle(false);
    }, []);

    return <div style={{position: 'relative'}} ref={wrapperRef}>
        <div className="option-bottom" style={{alignItems: 'flex-start'}}>
            <DebounceInput
                value={value}
                style={{outline: 'none'}}
                onFocus={(e) => {
                    if(!e.target.value) return;
                    setToggle(true);
                }}
                placeholder={''}
                minLength={2}
                debounceTimeout={300}
                onChange={e => {
                    setValue(e.target.value);
                    if(!e.target.value) return;
                    onSearch(e.target.value);
                }} />
        </div>
        <div className={classNames(styles.dropdownMenu, toggle && styles.displayBlock)} style={{minWidth: 150}}>
            {suggestions.map((suggestion, index) => {
                return <div onClick={() => onAddPlayer(suggestion)} className={styles.dropdownMenuItem} key={index}>
                    {suggestion.player_name}
                </div>
            })}
            {suggestions.length === 0 && <div style={{
                padding: 10,
                textAlign: 'left',
                color: '#9e9e9e',
            }}>
                見つかりません
            </div>}
        </div>
    </div>
}

const clickOutsideConfig = {
    handleClickOutside: () => PlayerSearch.handleClickOutside
};

export default onClickOutside(PlayerSearch, clickOutsideConfig);

